export default __webpack_public_path__ + "static/media/alphabet-yellow-z.ff526388.png";